
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"line-height":"normal","text-indent":"0","text-align":"start","text-decoration-line":"none","text-decoration-style":"solid","text-decoration-color":"#000","text-transform":"none","block-progression":"tb","isolation":"auto","mix-blend-mode":"normal"},attrs:{"d":"M20 3v4h-7c-4.947 0-9 4.053-9 9a2 2 0 00.158.78 2 2 0 000 .001C4.577 21.348 8.33 25 13 25h3a2 2 0 100-4h-3a4.97 4.97 0 01-5-5c0-2.785 2.215-5 5-5h7v4l6-6-6-6z","font-weight":"400","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    